import { Building2, Plus } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router';

import { useUsuario } from '@/lib/auth/contexto';
import { podeNaPlataforma } from '@/lib/auth/permissoes';
import { EstadoVazio } from '@/ui/components/estado-vazio';
import { Kpi } from '@/ui/components/kpi';
import { TabelaDados } from '@/ui/components/tabela-dados';
import { CabecalhoPagina } from '@/ui/patterns/cabecalho-pagina';
import { PaginaLista } from '@/ui/patterns/pagina-lista';
import { Button } from '@/ui/primitives/button';

import { useEmpresas } from './api';
import { colunasEmpresas } from './colunas';
import { DialogoNovaEmpresa } from './dialogo-nova-empresa';

export function PaginaEmpresas() {
  const usuario = useUsuario();
  const navegar = useNavigate();
  const consulta = useEmpresas();
  const [nova, setNova] = useState(false);
  const podeCriar = podeNaPlataforma(usuario, 'plataforma.empresas.gerenciar');
  const empresas = consulta.data ?? [];
  const comPendencia = empresas.filter((e) => e.pendencias.length > 0).length;

  return (
    <PaginaLista
      cabecalho={
        <CabecalhoPagina
          titulo="Empresas"
          descricao="O cadastro fiscal de cada empresa define como as notas dela são lidas e conferidas."
          acoes={
            podeCriar && (
              <Button
                variante="primario"
                onClick={() => {
                  setNova(true);
                }}
              >
                <Plus aria-hidden /> Nova empresa
              </Button>
            )
          }
        />
      }
      indicadores={
        <>
          <Kpi
            rotulo="Empresas"
            valor={consulta.data ? empresas.length : null}
            icone={<Building2 aria-hidden />}
            destaque
          />
          <Kpi
            rotulo="Com pendência fiscal"
            valor={consulta.data ? comPendencia : null}
            detalhe="Regime, inscrição ou certificado faltando"
          />
        </>
      }
      lista={
        <TabelaDados
          rotulo="Empresas"
          className="flex-1"
          colunas={colunasEmpresas}
          dados={empresas}
          idLinha={(e) => e.id}
          carregando={consulta.isPending}
          aoAbrir={(e) => void navegar(`/empresas/${e.id}`)}
          vazio={
            podeCriar ? (
              <EstadoVazio
                icone={<Building2 />}
                titulo="Nenhuma empresa cadastrada"
                texto="Use Nova empresa para cadastrar a primeira — o CNPJ basta para começar."
              />
            ) : (
              <EstadoVazio
                icone={<Building2 />}
                titulo="Nenhuma empresa no seu acesso"
                texto="Peça à administração para vincular você às empresas em que trabalha."
              />
            )
          }
        />
      }
      detalhe={podeCriar && <DialogoNovaEmpresa aberto={nova} aoMudar={setNova} />}
    />
  );
}
